import React from "react";

const NotFound = () => {
    return (
        <div className="my-12">
            <h1 className="text-5xl text-orange text-center ">404</h1>
            <h1 className="text-3xl text-orange text-center ">Not Found Anything</h1>
        </div>
    );
}
export default NotFound;